import { FC } from 'react';
import { Box, Typography } from '@mui/material';

const BusinessPriorityTooltip: FC<
  React.PropsWithChildren<BusinessPriorityTooltipProps>
> = props => {
  const { userCount, codeChanges, lastCodeChange } = props;

  return (
    <Box p={1}>
      <Typography variant='body2' color='text.primary' mb={1}>
        Business priority is the relative importance of the application.
        <br />
        <br />
        Business priority calculated based on: <br />
        Unique Users: {userCount} <br />
        PRs/Push Events: {codeChanges} <br />
        Last code change: {lastCodeChange}
        <br />
      </Typography>
    </Box>
  );
};

export interface BusinessPriorityTooltipProps {
  userCount: number;
  codeChanges: number;
  lastCodeChange: string;
}

export default BusinessPriorityTooltip;
